import React from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

/**
 * A reusable Base Dialog component that provides a consistent structure for dialogs.
 * It includes a title, content area, and a close button.
 *
 * @param {object} props - The component props.
 * @param {boolean} props.open - Controls whether the dialog is open or closed.
 * @param {function} props.onClose - Callback function triggered when the dialog is requested to close.
 * @param {React.ReactNode} props.title - The title to display in the dialog header.
 * @param {React.ReactNode} props.children - The content to display within the dialog.
 * @param {string} [props.maxWidth='sm'] - Determines the maximum width of the dialog.
 * @param {boolean} [props.fullWidth=true] - If `true`, the dialog will take up the full width of its container.
 */
const BaseDialog = ({ open, onClose, title, children, maxWidth = 'sm', fullWidth = true }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    {title}
                    {onClose
                        ? (
                            <IconButton aria-label="close" onClick={onClose} size="small">
                                <CloseIcon />
                            </IconButton>
                        )
                        : null}
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default BaseDialog
